import { toBooleanFromBit } from './productDetailTabTypeHelpers';

const parseContentConfig = (value) => {
  if (value == null || value === '') return {};
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(String(value));
  } catch {
    return {};
  }
};

export const mapProductDetailTabTypeFromApi = (row) => {
  if (!row) return null;
  return {
    TabTypeId: row.TabTypeId ?? null,
    TabKey: row.TabKey || '',
    DefaultTitle: row.DefaultTitle || '',
    ContentType: row.ContentType || 'html_block',
    ContentConfig: parseContentConfig(row.ContentConfig),
    Placement: row.Placement || 'tab',
    HelpText: row.HelpText || '',
    DisplayOrder: row.DisplayOrder ?? 0,
    IsActive: toBooleanFromBit(row.IsActive, true),
  };
};

export const buildProductDetailTabTypeSavePayload = (data, userId) => ({
  TabTypeId: data.TabTypeId || null,
  TabKey: data.TabKey?.trim() || '',
  DefaultTitle: data.DefaultTitle?.trim() || '',
  ContentType: data.ContentType?.trim() || '',
  ContentConfig: data.ContentConfig || {},
  Placement: data.Placement || 'tab',
  HelpText: data.HelpText?.trim() || null,
  DisplayOrder: data.DisplayOrder ?? 0,
  IsActive: 1,
  UserId: userId,
});
